import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ColumnDef, OrderModel } from "../../models/orders/order-list-model";
import { useTranslation } from "react-i18next";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";

interface DataTableProps {
  data: any[];
  totalRecords : number;
  pageNumber : number
  pageSize : number;
  onPageChange : any
}

const GSTSalesReportListDataTable: React.FC<DataTableProps> = ({ data , totalRecords,pageNumber,pageSize,onPageChange}) => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [orderDataList, setOrderDataList] = useState<OrderModel[]>(data);
  const [orderTotalCount,setorderTotalCount] = useState<number>(totalRecords)

  useEffect(() => {
    setOrderDataList(data);
    setorderTotalCount(totalRecords)
  },[data]);

  const columns: ColumnDef[] = [
    {
      field: "invoiceNumber",
      header: t("orderlist_table_invoiceno"),
      style: { minWidth: "4rem" },
      cell: (row: any) =>
          <>
            <span style={{color: "darkcyan",fontWeight: "bolder" }}>
              {row.invoiceNo}
            </span>
          </>
    },
    {
      field: "invoiceDate",
      header: t("orderlist_table_invoicedate"),
      style: { minWidth: "4rem" },
      cell: (row: any) =>
       new Date(row.invoiceDate).toLocaleDateString("en-gb", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
    },
    {
      field: "userName",
      header: t("orderlist_table_username"),
      style: { minWidth: "4rem" },
      sortable: true,
      cell: (row: any) => row.userName,
    },
    {
      field: "mobileNumber",
      header: t("orderlist_table_mobile"),
      style: { minWidth: "4rem" },
      sortable: true,
      cell: (row: any) => row.mobileNumber,
    },
    {
      field: "state",
      header: t("orderlist_table_state"),
      style: { minWidth: "6rem" },
      sortable: true,
      cell: (row: any) => row.state,
    },
  ];

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <div className="col-12 card border-noround p-2">
        {orderDataList !== null ?<DataTable
            value={orderDataList}
            paginator
            first={(pageNumber - 1) * pageSize}
            totalRecords={totalRecords}
            rows={10}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            stripedRows
            showGridlines
            emptyMessage="No order found."
            sortMode="multiple"
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            onPage={onPageChange}
            lazy
          >
            {columns.map((col, i) => (
              <Column
                key={i}
                field={col.field}
                sortable={col.sortable}
                header={col.header}
                style={col.style}
                body={col.cell}
              />
            ))}
          </DataTable> : ""}
      </div>
    </>
  );
};
export default GSTSalesReportListDataTable;